import { AuthConsumer } from "./authProvider";

function Signin(props: any) {
    const { children } = props;
    return (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (isAuthenticated()) {
                    return children;
                } else {
                    signinRedirect();
                    return <span>loading</span>;
                }
            }}
        </AuthConsumer>
    );
}

export default Signin;
